// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import EventTypeServiceForm, {
  Props as EventTypeServiceFormProps,
} from 'presentations/views/components/organisms/EventTypeServiceForm';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';

export type Props = EventTypeServiceFormProps;

export default function Component(props: Props) {
  const t = translateInComponent(translations);

  return (
    <StyledContainer>
      <StyledHeaderNavigation>
        <StyledHeader>{t('Optional Service')}</StyledHeader>
      </StyledHeaderNavigation>
      <StyledEventTypeServiceFormContainer>
        <EventTypeServiceForm {...props} />
      </StyledEventTypeServiceFormContainer>
    </StyledContainer>
  );
}

const StyledContainer = styled.div``;
// EventTypeServiceFormはそのまま使いたいが余計なpaddingが入っているため、
// スタイルを打ち消すContainerでラップする。
// 最終的にはEventTypeServiceFormがpaddingを持たないようにする。
const StyledEventTypeServiceFormContainer = styled.div`
  margin-top: ${spacing(40)};

  > div {
    padding: 0;
  }

  ${mediaMax.tablet} {
    margin-top: 0;
  }
`;
const StyledHeaderNavigation = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${mediaMax.tablet} {
    display: none;
  }
`;
const StyledHeader = styled.div`
  font-size: ${fontSize(20)};
  font-weight: ${fontWeight('bold')};
  line-height: 1.48;
`;
